import { compose } from '@/shared/lib/compose.lib'

import withBrouserRouter from './hooks/with-brouser-router'
import withStore from './hooks/with-store'
import withUiKit from './hooks/with-ui-kit'
import Router from './routers'

const App = () => {
  return <Router />
}

export default compose(withBrouserRouter, withStore, withUiKit)(App)
